

const AUTH_KEYS = {
  TOKEN: "psy_token",
  REFRESH_TOKEN: "psy_refresh_token",
  USER_ID: "psy_id",
  USER_NAME: "psy_usuario",
  USER_EMAIL: "psy_email",

  PLAN: "plano",
  PLAN_ORIGINAL: "planoOriginal",
  PLAN_NORMALIZED: "planoNormalizado",
  PLAN_VALUE: "valorPlano",

  PREMIUM: "premium",
  PREMIUM_ENABLED: "premiumLiberado",

  SUBSCRIPTION_STATUS: "statusAssinatura",
  SUBSCRIPTION_ACTIVE: "assinaturaAtiva",
  SUBSCRIPTION_ACTIVE_DB: "assinaturaAtivaBanco",
  SUBSCRIPTION_VALID: "assinaturaValida",

  RESOURCES: "recursos",

  SCHEDULED_PLAN: "planoAgendado",
  SCHEDULED_PLAN_VALUE: "valorPlanoAgendado",

  DOWNGRADE_SCHEDULED: "downgradeAgendado",
  DOWNGRADE_EFFECTIVE: "downgradeJaEfetivo",
  DOWNGRADE_EFFECTIVE_AT: "downgradeEfetivoEm",
  DOWNGRADE_REQUESTED_AT: "downgradeSolicitadoEm",
  DOWNGRADE_SCHEDULE_ID: "downgradeScheduleId",

  CURRENT_PERIOD_END: "currentPeriodEnd",
  SUBSCRIPTION_EXPIRATION: "vencimentoAssinatura",

  IS_TRIAL: "isTrial",
  TRIAL_END_AT: "trialEndsAt",

  SUBSCRIPTION_NOTICE: "avisoAssinatura",
  DOWNGRADE_NOTICE: "avisoDowngrade",
};
const SUBSCRIPTION_KEYS = [
AUTH_KEYS.PLAN,
AUTH_KEYS.PLAN_ORIGINAL,
AUTH_KEYS.PLAN_NORMALIZED,
AUTH_KEYS.PLAN_VALUE,

AUTH_KEYS.PREMIUM,
AUTH_KEYS.PREMIUM_ENABLED,

AUTH_KEYS.SUBSCRIPTION_STATUS,
AUTH_KEYS.SUBSCRIPTION_ACTIVE,
AUTH_KEYS.SUBSCRIPTION_ACTIVE_DB,
AUTH_KEYS.SUBSCRIPTION_VALID,

AUTH_KEYS.RESOURCES,

AUTH_KEYS.SCHEDULED_PLAN,
AUTH_KEYS.SCHEDULED_PLAN_VALUE,

AUTH_KEYS.DOWNGRADE_SCHEDULED,
AUTH_KEYS.DOWNGRADE_EFFECTIVE,
AUTH_KEYS.DOWNGRADE_EFFECTIVE_AT,
AUTH_KEYS.DOWNGRADE_REQUESTED_AT,
AUTH_KEYS.DOWNGRADE_SCHEDULE_ID,

AUTH_KEYS.CURRENT_PERIOD_END,
AUTH_KEYS.SUBSCRIPTION_EXPIRATION,

AUTH_KEYS.IS_TRIAL,
AUTH_KEYS.TRIAL_END_AT,

AUTH_KEYS.SUBSCRIPTION_NOTICE,
AUTH_KEYS.DOWNGRADE_NOTICE,
];

function safeSetItem(storage, key, value) {
if (!storage || !key) {
  return false;
}

try {
  storage.setItem(key, value);
  return true;
} catch (error) {
  console.error(
    `Erro ao salvar ${key} no storage:`,
    error
  );
  return false;
}
}

function safeGetItem(storage, key) {
if (!storage || !key) {
  return "";
}

try {
  return storage.getItem(key) || "";
} catch (error) {
  console.error(
    `Erro ao ler ${key} do storage:`,
    error
  );
  return "";
}
}

function safeRemoveItem(storage, key) {
if (!storage || !key) {
  return false;
}

try {
  storage.removeItem(key);
  return true;
} catch (error) {
  console.error(
    `Erro ao remover ${key} do storage:`,
    error
  );
  return false;
}
}

function writeStorage(
key,
value,
{
  local = true,
  session = true,
} = {}
) {
if (!key) {
  return;
}

const normalized =
  value === undefined ||
  value === null
    ? ""
    : String(value);

// IMPORTANTE: cada storage é tratado de forma independente.
// Em alguns navegadores móveis um storage pode estar indisponível
// enquanto o outro continua funcionando. Um erro no localStorage
// não pode impedir a gravação no sessionStorage (e vice-versa).
if (local) {
  safeSetItem(
    localStorage,
    key,
    normalized
  );
}

if (session) {
  safeSetItem(
    sessionStorage,
    key,
    normalized
  );
}
}

function writeJsonStorage(
key,
value,
options
) {
let json = "{}";

try {
  json = JSON.stringify(
    value || {}
  );
} catch {
  json = "{}";
}

writeStorage(
  key,
  json,
  options
);
}

function removeStorageKey(key) {
// Remove de forma independente para que falha em um storage
// não impeça a limpeza do outro.
safeRemoveItem(
  localStorage,
  key
);
safeRemoveItem(
  sessionStorage,
  key
);
}

function writeOptional(
key,
value
) {
if (
  value === undefined ||
  value === null ||
  String(value).trim() === ""
) {
  removeStorageKey(key);
  return;
}

writeStorage(key, value);
}

export function limparDadosAssinatura() {
SUBSCRIPTION_KEYS.forEach(
  removeStorageKey
);
}

export function limparSessaoPsyAssist() {
Object.values(AUTH_KEYS).forEach(
  removeStorageKey
);
}

export function salvarSessaoPsyAssist(
data = {}
) {
if (
  !data ||
  typeof data !== "object"
) {
  throw new Error(
    "Resposta de login inválida."
  );
}

const token =
  data.accessToken ||
  data.token ||
  "";

const userId =
  data.id ||
  data.userId ||
  data._id ||
  "";

if (!token) {
  throw new Error(
    "O login não retornou o token de acesso."
  );
}

if (!userId) {
  throw new Error(
    "O login não retornou o ID do usuário."
  );
}

limparDadosAssinatura();

writeStorage(
  AUTH_KEYS.TOKEN,
  token
);

writeOptional(
  AUTH_KEYS.REFRESH_TOKEN,
  data.refreshToken
);

writeStorage(
  AUTH_KEYS.USER_ID,
  userId
);

writeStorage(
  AUTH_KEYS.USER_NAME,
  data.nome ||
    data.nomeUsuario ||
    ""
);

writeStorage(
  AUTH_KEYS.USER_EMAIL,
  data.email || ""
);

writeStorage(
  AUTH_KEYS.PLAN,
  String(
    data.plano ||
    "essencial"
  ).toLowerCase()
);

writeStorage(
  AUTH_KEYS.PLAN_ORIGINAL,
  String(
    data.planoOriginal ||
    data.plano ||
    "essencial"
  ).toLowerCase()
);

writeStorage(
  AUTH_KEYS.PLAN_NORMALIZED,
  String(
    data.planoNormalizado ||
    data.plano ||
    "essencial"
  ).toLowerCase()
);

writeStorage(
  AUTH_KEYS.PLAN_VALUE,
  data.valorPlano ?? 0
);

writeStorage(
  AUTH_KEYS.PREMIUM,
  data.premium === true
);

writeStorage(
  AUTH_KEYS.PREMIUM_ENABLED,
  data.premiumLiberado === true
);

writeStorage(
  AUTH_KEYS.SUBSCRIPTION_STATUS,
  data.statusAssinatura || ""
);

writeStorage(
  AUTH_KEYS.SUBSCRIPTION_ACTIVE,
  data.assinaturaAtiva === true
);

writeStorage(
  AUTH_KEYS.SUBSCRIPTION_ACTIVE_DB,
  data.assinaturaAtivaBanco === true
);

writeStorage(
  AUTH_KEYS.SUBSCRIPTION_VALID,
  data.assinaturaValida === true
);

writeJsonStorage(
  AUTH_KEYS.RESOURCES,
  data.recursos || {}
);

writeOptional(
  AUTH_KEYS.SCHEDULED_PLAN,
  data.planoAgendado
);

writeOptional(
  AUTH_KEYS.SCHEDULED_PLAN_VALUE,
  data.valorPlanoAgendado
);

writeStorage(
  AUTH_KEYS.DOWNGRADE_SCHEDULED,
  data.downgradeAgendado === true
);

writeStorage(
  AUTH_KEYS.DOWNGRADE_EFFECTIVE,
  data.downgradeJaEfetivo === true
);

writeOptional(
  AUTH_KEYS.DOWNGRADE_EFFECTIVE_AT,
  data.downgradeEfetivoEm
);

writeOptional(
  AUTH_KEYS.DOWNGRADE_REQUESTED_AT,
  data.downgradeSolicitadoEm
);

writeOptional(
  AUTH_KEYS.DOWNGRADE_SCHEDULE_ID,
  data.downgradeScheduleId
);

writeOptional(
  AUTH_KEYS.CURRENT_PERIOD_END,
  data.currentPeriodEnd
);

writeOptional(
  AUTH_KEYS.SUBSCRIPTION_EXPIRATION,
  data.vencimentoAssinatura
);

writeStorage(
  AUTH_KEYS.IS_TRIAL,
  data.isTrial === true
);

writeOptional(
  AUTH_KEYS.TRIAL_END_AT,
  data.trialEndsAt
);

if (data.avisoAssinatura) {
  writeJsonStorage(
    AUTH_KEYS.SUBSCRIPTION_NOTICE,
    data.avisoAssinatura
  );
} else {
  removeStorageKey(
    AUTH_KEYS.SUBSCRIPTION_NOTICE
  );
}

if (data.avisoDowngrade) {
  writeJsonStorage(
    AUTH_KEYS.DOWNGRADE_NOTICE,
    data.avisoDowngrade
  );
} else {
  removeStorageKey(
    AUTH_KEYS.DOWNGRADE_NOTICE
  );
}

return {
  token,
  userId: String(userId),
  plano:
    String(
      data.plano ||
      "essencial"
    ).toLowerCase(),
  premium:
    data.premium === true,
  recursos:
    data.recursos || {},
};
}

export function atualizarDadosAssinatura(
data = {}
) {
const token =
  safeGetItem(
    sessionStorage,
    AUTH_KEYS.TOKEN
  ) ||
  safeGetItem(
    localStorage,
    AUTH_KEYS.TOKEN
  );

const userId =
  safeGetItem(
    sessionStorage,
    AUTH_KEYS.USER_ID
  ) ||
  safeGetItem(
    localStorage,
    AUTH_KEYS.USER_ID
  );

const nome =
  safeGetItem(
    sessionStorage,
    AUTH_KEYS.USER_NAME
  ) ||
  safeGetItem(
    localStorage,
    AUTH_KEYS.USER_NAME
  );

const email =
  safeGetItem(
    sessionStorage,
    AUTH_KEYS.USER_EMAIL
  ) ||
  safeGetItem(
    localStorage,
    AUTH_KEYS.USER_EMAIL
  );

return salvarSessaoPsyAssist({
  ...data,
  accessToken:
    data.accessToken ||
    token,
  id:
    data.id ||
    userId,
  nome:
    data.nome ||
    nome,
  email:
    data.email ||
    email,
});
}

export { AUTH_KEYS };